import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Modal } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const response = await axios.post(`${config.apiBaseUrl}/api/login`, values);
      const { access_token } = response.data;
      
      login(access_token);
      message.success('登录成功');
      navigate('/search');
    } catch (error) {
      message.error(error.response?.data?.message || '登录失败');
    }
  };

  const handleForgotPassword = async (values) => {
    try {
      await axios.post(`${config.apiBaseUrl}/api/forgot-password`, {
        email: values.email
      });
      message.success('重置密码链接已发送到您的邮箱');
      setForgotPasswordVisible(false);
      form.resetFields();
    } catch (error) {
      message.error(error.response?.data?.message || '发送重置密码邮件失败');
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: 'calc(100vh - 64px)',
      background: '#f5f5f7'
    }}>
      <Card
        style={{
          width: 400,
          borderRadius: '20px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          background: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(20px)',
          border: 'none'
        }}
        title={
          <h2 style={{ 
            textAlign: 'center', 
            margin: 0,
            fontWeight: '500'
          }}>
            登录
          </h2>
        }
      >
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              block
              size="large"
              style={{
                borderRadius: '20px',
                height: '40px',
                fontSize: '16px'
              }}
            >
              登录
            </Button>
          </Form.Item>

          <div style={{ 
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '20px'
          }}>
            <Link onClick={() => setForgotPasswordVisible(true)}>忘记密码？</Link>
            <Link to="/register">立即注册</Link>
          </div>
        </Form>
      </Card>

      <Modal
        title="忘记密码"
        open={forgotPasswordVisible}
        onCancel={() => setForgotPasswordVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          onFinish={handleForgotPassword}
          layout="vertical"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入邮箱地址' },
              { type: 'email', message: '请输入有效的邮箱地址' }
            ]}
          >
            <Input 
              prefix={<MailOutlined />}
              placeholder="请输入您的注册邮箱"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              block
              size="large"
              style={{
                borderRadius: '20px',
                height: '40px',
                fontSize: '16px'
              }}
            >
              发送重置密码链接
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Login;